/**
 * @file BlogSlotsLine.tsx
 * @description «Блоков над лентой: N · под лентой: M — [Изменить на
 * странице ›]» в панели «Блог» (phase19.16 Р2; uiux-design-r2 §8;
 * контракт §16.5 `GET /admin/site/slots`). Ссылка открывает экран «Блог» в
 * конструкторе — там блоки мест правятся, как блоки страницы.
 * Без права на контент строки нет (места — страницы сайта).
 */

import { useEffect, useState } from "react";

import { useHasPermission } from "../../../auth/hooks";
import { useBuilderLink } from "../../../hooks/site-builder/useBuilderLink";
import { sitePages, type SiteSlotItem } from "../../../lib/api-site-pages";
import { Link } from "react-router";

import { JUMP_LINK_CLASS } from "../../ui/jump-link";

export function BlogSlotsLine() {
  const canEdit = useHasPermission("SHOP_MANAGE_CONTENT");
  const link = useBuilderLink();
  const [slots, setSlots] = useState<SiteSlotItem[] | null>(null);
  useEffect(() => {
    if (!canEdit) return;
    let alive = true;
    sitePages
      .slots()
      .then((list) => alive && setSlots(list))
      .catch(() => alive && setSlots(null));
    return () => {
      alive = false;
    };
  }, [canEdit]);
  if (!canEdit) return null;
  const count = (key: SiteSlotItem["slot"]) => slots?.find((s) => s.slot === key)?.blocksCount ?? 0;
  return (
    <p className="type-caption flex flex-wrap items-center gap-x-2 rounded-lg bg-surface-low px-3 py-2 text-on-surface-variant">
      {slots ? `Блоков над лентой: ${count("BLOG_FEED_ABOVE")} · под лентой: ${count("BLOG_FEED_BELOW")} · под статьёй: ${count("ARTICLE_BELOW")}` : "Блоки над и под лентой"}
      <Link to={link({ screen: "blog", panel: null })} className={JUMP_LINK_CLASS}>
        Изменить на странице ›
      </Link>
    </p>
  );
}
